import React from 'react'
import './icon.css'

/**
 * Icon 
 */
export const Icon = ({ icon, size = "normal", clickable = false, action, eventPropagation = false }) => {

    function click (event) {
        if (!eventPropagation) {
            event.stopPropagation()
            event.preventDefault();
        }
        if (action) action(event)
    }

    const clicker = clickable ? "clickable" : ""
    return (
        <i className={`icon ${size} ${clicker} material-icons`} onClick={click}>
            {icon}
        </i>
    )
}